import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'safehtml',
    standalone: false
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(protected sanitizer: DomSanitizer) { }

  transform(input: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(input);
  }
}
